import { z } from "zod";

export const MassnahmenStatus = z.enum(["Offen", "InBearbeitung", "Erledigt", "Verworfen"]);
export type MassnahmenStatus = z.infer<typeof MassnahmenStatus>;

export const MassnahmenPriority = z.enum(["niedrig", "mittel", "hoch"]);
export type MassnahmenPriority = z.infer<typeof MassnahmenPriority>;

export const Massnahme = z.object({
  id: z.number().int().positive(),
  code: z.string(),
  addedAt: z.number().int(),
  description: z.string(),
  notes: z.string().nullable(),
  responsibleUserId: z.number().int().nullable(),
  operationalUserId: z.number().int().nullable(),
  dueDate: z.number().int().nullable(),
  status: MassnahmenStatus,
  statusNote: z.string().nullable(),
  priority: MassnahmenPriority.nullable(),
  origin: z.string().nullable(),
  externalAuditFinding: z.string().nullable(),
  internalAuditFinding: z.string().nullable(),
  createdAt: z.number().int(),
  updatedAt: z.number().int(),
});
export type Massnahme = z.infer<typeof Massnahme>;

export const MassnahmeCreate = z.object({
  code: z.string().min(1).max(80).optional(),
  description: z.string().min(1).max(5000),
  notes: z.string().max(5000).nullable().optional(),
  responsibleUserId: z.number().int().positive().nullable().optional(),
  operationalUserId: z.number().int().positive().nullable().optional(),
  dueDate: z.number().int().positive().nullable().optional(),
  status: MassnahmenStatus.optional(),
  statusNote: z.string().max(2000).nullable().optional(),
  priority: MassnahmenPriority.nullable().optional(),
  origin: z.string().max(2000).nullable().optional(),
  externalAuditFinding: z.string().max(2000).nullable().optional(),
  internalAuditFinding: z.string().max(2000).nullable().optional(),
});
export type MassnahmeCreate = z.infer<typeof MassnahmeCreate>;

export const MassnahmeUpdate = MassnahmeCreate.partial();
export type MassnahmeUpdate = z.infer<typeof MassnahmeUpdate>;
